import gql from 'fraql'
const metaQueries = {
  GET_DELIVERY_STATS: gql`
    query {
      getDeliveryStats {
        nodes {
          id
          time
          pickup
          timeInterval {
            hours
            minutes
          }
          idWorkerSetted
        }
      }
    }
  `,
  SET_DELIVERY_STATS: gql`
  mutation setStats($pickup: Boolean!, $hours: Int!, $minutes: Int!) {
    setDeliveryStats(input: {pickup: $pickup, hours: $hours, minutes: $minutes})  {
      integer
    }
  }`
}
export default metaQueries




// WEBPACK FOOTER //
// ./src/graphql/metaQueries.js